import Axios from "./axios";

const resource = "video-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}